import {getEmbedUrl} from "../../../../utils/legalServers";
import React, {useEffect, useState} from "react";
import {getTmdbImage} from "../../../../utils/consts";
import {
    formatFileSize,
    getAudioFromMetadata,
    getDurationFromMetadata,
    getSubtitlesFromMetadata
} from "../../../../utils/utils";
import CustomFilePlayer from "../customFilePlayer/customFilePlayer";
import {toast} from "react-toastify";
import {TorresstreamApi} from "../../../../apis/torrestream-api/torresstream-api";

const TowersStreamViewer = ({type, tmdbId, season, episode, imagePath, item, onGoNextEpisode, squadFlixTvHook}) => {

    const [torrentId, setTorrentId] = React.useState(null);
    const [selectedTorrent, setSelectedTorrent] = React.useState(null);
    const [torrents, setTorrents] = React.useState([]);
    const [existingTorrents, setExistingTorrents] = React.useState([]);
    const [torrentsLoading, setTorrentsLoading] = React.useState(false);
    const [showDownloadInfo, setShowDownloadInfo] = React.useState(false);
    const [downloadInfo, setDownloadInfo] = React.useState({});
    const videoRef = React.useRef(null);
    const downloadInterval = React.useRef(null);
    const [videoUrl, setVideoUrl] = React.useState(null);
    const wasConverting = React.useRef(false);
    const [torrentRuntime, setTorrentRuntime] = React.useState(null);
    const [videoOriginalUrl, setVideoOriginalUrl] = React.useState(null);
    const [subtitles, setSubtitles] = useState([]);
    const [audios, setAudios] = useState([]);

    const loadTorrents = (ignoreExisting = false) => {
        setTorrentsLoading(true);

        if (type === "movie") {
            TorresstreamApi.getMovieTorrents(tmdbId, ignoreExisting).then(res => {
                setExistingTorrents(res.existingTorrents);
                setTorrents(res.torrents.map(torrent => ({
                    existing: res.existingTorrents?.find(et => et.id === torrent.id),
                    ...torrent
                })).sort((a, b) => a.existing ? -1 : 1));
                setTorrentsLoading(false);

                if (!ignoreExisting) {
                    if (res.existingTorrents?.length) {
                        handleSelectTorrent(res.existingTorrents[0]);
                    } else {
                        loadTorrents(true);
                    }
                }
            });
        } else {
            TorresstreamApi.getEpisodeTorrents(tmdbId, season, episode, ignoreExisting).then(res => {
                setExistingTorrents(res.existingTorrents);
                setTorrents(res.torrents.map(torrent => ({
                    existing: res.existingTorrents?.find(et => et.id === torrent.id),
                    ...torrent
                })).sort((a, b) => a.existing ? -1 : 1));

                setTorrentsLoading(false);

                if (!ignoreExisting) {
                    if (res.existingTorrents?.length) {
                        handleSelectTorrent(res.existingTorrents[0]);
                    } else {
                        loadTorrents(true);
                    }
                }
            });
        }
    }

    useEffect(() => {
        loadTorrents();

        return () => {
            if (downloadInterval.current) {
                clearInterval(downloadInterval.current);
            }
        }
    }, [type, tmdbId, imagePath, season, episode]);

    const handleCloseViewer = () => {
        if (downloadInterval.current) {
            clearInterval(downloadInterval.current);
        }
        setTorrentId(null);
        loadTorrents(true);
    }

    const handleSelectTorrent = (torrent) => {
        setSelectedTorrent(torrent);
        setTorrentsLoading(true);
        TorresstreamApi.downloadTorrent(torrent.id, tmdbId, season, episode).then(() => {
            downloadInterval.current = setInterval(() => {
                TorresstreamApi.getDownloadProgress(torrent.id).then(res => {
                    setDownloadInfo(res);
                    if (wasConverting.current && !res.converting) {
                        // Si estaba convirtiendo y ya no lo está, recargar el video
                        videoRef.current.reload();
                    }
                    wasConverting.current = res.converting;
                    if (!res.downloading && !res.converting) {
                        if (downloadInterval.current) {
                            clearInterval(downloadInterval.current);
                        }
                        setTimeout(() => {
                            setShowDownloadInfo(false);
                        }, 2000);
                    } else {
                        setShowDownloadInfo(true);
                    }
                }).catch(err => {
                    console.error("Error getting progress", err);
                })
            }, 1000);
            setTorrentsLoading(false);
            setTorrentId(torrent.id);
        });

    }

    useEffect(() => {
        if (!torrentId) {
            setVideoUrl(null);
            setTorrentRuntime(item?.runtime ?? 0);
            return;
        }

        setSubtitles([]);
        setAudios([]);
        setTorrentRuntime(0);

        TorresstreamApi.getTorrentFileDetails(torrentId).then(res => {
            setTorrentRuntime(getDurationFromMetadata(res.metadata, item));
            setAudios(getAudioFromMetadata(res.metadata));
            setSubtitles(getSubtitlesFromMetadata(res.metadata));
        }).catch(err => {
            toast.error(err);
        });
        setVideoUrl(getEmbedUrl("TowersStream", undefined, torrentId, undefined, undefined));
        setVideoOriginalUrl(TorresstreamApi.get('originalFile').getUrl({torrentId}));
    }, [item.runtime, torrentId]);

    if (!torrentId) {
        return (
            <div className="towersStreamViewer__torrents">
                <div className="towersStreamViewer__torrents__background">
                    {torrentsLoading &&
                        <div
                            className="d-flex flex-column justify-content-center align-items-center ps-4 pe-4 text-center text-light">
                            <div className="spinner-border text-light" role="status">
                            </div>
                            <div>
                                Consiguiendo torrents para este contenido
                            </div>
                            <div style={{
                                color: "rgb(255,255,255, 0.7)",
                            }}>
                                Esto puede tardar unos segundos
                            </div>
                        </div>}
                    {!torrentsLoading && !torrents.length &&
                        <div className="text-light">
                            No se encontraron torrents para este contenido
                        </div>
                    }
                    {!torrentsLoading && !!torrents.length &&
                        <div className="towersStreamViewer__torrents__content">
                            <div className="towersStreamViewer__torrents__list">
                                <div className="text-light">
                                    Selecciona un torrent para descargar
                                </div>
                                <div className="towersStreamViewer__torrents__list__buttons">
                                    {existingTorrents.map(torrent => {
                                        return <button className="btn btn-outline-light"
                                                       key={torrent.id}
                                                       onClick={() => handleSelectTorrent(torrent)}>
                                            {torrent.name} · {formatFileSize(torrent.downloaded_size ?? 0)}
                                            <i className="fa-solid fa-floppy-disk"></i>
                                        </button>
                                    })}
                                    {torrents.map(torrent => {
                                        return <button className="btn btn-outline-light"
                                                       key={torrent.id + "_" + torrent.Size}
                                                       onClick={() => handleSelectTorrent(torrent)}>
                                            {torrent.Title} · {formatFileSize(torrent.Size)}
                                            {torrent.existing && <> · <i className="fa-solid fa-floppy-disk"></i></>}
                                        </button>
                                    })}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>);
    }

    if (!selectedTorrent) {
        return null;
    }


    return (<CustomFilePlayer videoUrl={videoUrl} imagePath={getTmdbImage(imagePath)}
                              title={selectedTorrent.Title ?? selectedTorrent.name}
                              customRuntime={torrentRuntime} ref={videoRef}
                              onGoNextEpisode={onGoNextEpisode}
                              squadFlixTvHook={squadFlixTvHook}
                              audios={audios} subtitles={subtitles}
                              onClosePlayer={handleCloseViewer} item={item}
                              streaming={true} originalVideoUrl={videoOriginalUrl}
                              downloadInfo={showDownloadInfo ? downloadInfo : undefined}/>);

}

export default TowersStreamViewer;
